const Specright = () => {};

export default Specright;
